export default __webpack_public_path__ + "static/media/planpng.c1b33337.png";